var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'modal': true,
  'is-active': _vm.active
}},[_c('div',{staticClass:"modal-background",on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('div',{staticClass:"new-window"},[_c('a',{attrs:{"target":"_blank","href":_vm.previewPath}},[_c('arrow-up-right-icon')],1)]),_c('div',{staticClass:"modal-content",on:{"click":function($event){return _vm.$emit('cancel')}}},[_c('img',{attrs:{"src":_vm.previewPath}})])])}
var staticRenderFns = []

export { render, staticRenderFns }